import React from "react";

const CheckBox = ({
  id,
  label = "",
  checked = false,
  onChange,
  disabled = false,
  tooltipText = "",
  className = "",
  ...rest
}) => {
  return (
    <div className={`form-check simcheck ${disabled ? "disable" : ""} ${className}`}>
      <input
        type="checkbox"
        className="form-check-input"
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        title={tooltipText}
        {...rest}
      />
      {label && (
        <label className="form-check-label" htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};

export default CheckBox;
